import { computed, ComputedRef, toValue, toRef } from 'vue';
import { useQueryV2 } from '@libs/use';
import { FrozenHistory } from '@libs/api-reference';

import * as API from '../requests';
import { OPTION_QUERY_KEYS } from '../constants';

interface getFrozenHistoryProps {
  isFreeze: ComputedRef<boolean> | boolean;
}

export default function useGetFrozenHistory({
  isFreeze,
}: getFrozenHistoryProps) {
  const {
    result,
    execute: getFrozenHistory,
    isPending: isLoadingFrozenHistory,
    isSuccess: isSuccessLoadingFrozenHistory,
    isError: isErrorLoadingFrozenHistory,
    isRevalidating: isRevalidatingFrozenHistory,
  } = useQueryV2<FrozenHistory>(
    () =>
      API.getFrozenHistory({
        isFreeze: toValue(isFreeze),
      }),
    {
      key: OPTION_QUERY_KEYS.frozenHistory(toRef({ isFreeze })),
      immediate: true,
      cacheTime: 1000 * 60 * 60, // 1h
      staleTime: 1000 * 60 * 60, // 1h
    }
  );

  const frozenHistory = computed(() => result.value?.data.items || []);

  return {
    frozenHistory,
    getFrozenHistory,
    isErrorLoadingFrozenHistory,
    isSuccessLoadingFrozenHistory,
    isLoadingFrozenHistory,
    isRevalidatingFrozenHistory,
  };
}
